<template>
    <div :id="'indicator_'+ indicator.id" class="card mt-3">
        <div class="card-body">
            <div class="row">
                <div class="col-1 indicator-title pr-0">
                    {{ indicator.section_number }}.{{ indicator.indicator_number }}
                </div>
                <div class="col-8 indicator-title pl-3">
                    {{ indicator.short_text }}
                    <small><i>
                        <a  data-toggle="collapse" 
                            :id="'toggle_details_indicator_'+ indicator.id" 
                            :href="'#details_indicator_'+ indicator.id" 
                            aria-expanded="false" 
                            :aria-controls="'indicator_details_'+ indicator.id"
                        >
                            toggle details
                        </a>
                    </i></small>
                </div>
                <div v-if="initialIndicators" class="col-3">
                    <select 
                        :value="initialIndicator.grade" 
                        class="form-control px-2 py-1"
                        :class="{ 'outline-red': initialIndicator.grade == null }"
                        :id="'grade_indicator_'+ indicator.id"
                        :disabled="initialIndicator.locked_at || cycle.completed_at" 
                        @change="updateIndicator($event, 'grade')"
                    >
                        <option value="" class="select-placeholder">Select Grade</option>
                        <option value="1">{{ scoringLabels[1] }} (1)</option>
                        <option value="2">{{ scoringLabels[2] }} (2)</option>
                        <option value="3">{{ scoringLabels[3] }} (3)</option>
                        <option value="4">{{ scoringLabels[4] }} (4)</option>
                        <option v-if="indicator.not_applicable" disabled>────────</option>
                        <option v-if="indicator.not_applicable" value="0">Not Applicable</option>
                    </select>
                </div>
            </div><!-- .row -->
            <div class="row">
                <div class="col">
                    <div class="collapse collapse-all details mt-2 pl-4" :id="'details_indicator_'+ indicator.id">
                        <div class="full-text mt-1">
                            <span v-html="indicator.full_text"></span>
                        </div>
                        <div class="law-rule mt-1">
                            <b><span v-html="indicator.law"></span></b>
                        </div>
                        <div class="best-practice mt-1">
                            <span v-html="indicator.best_practice"></span>
                        </div>
                        <div class="notes mt-1">
                            <span v-html="indicator.notes"></span>
                        </div>
                    </div>
                    <textarea 
                        v-if="initialIndicators" 
                        :value="initialIndicator.comment" 
                        class="form-control mt-3" 
                        :id="'comment_indicator_'+ indicator.id"
                        placeholder="Add comments here" 
                        :disabled="initialIndicator.locked_at || cycle.completed_at" 
                        @blur="updateIndicator($event, 'comment')"
                    ></textarea>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped>
.indicator-title {
    font-size: 1em;
    font-weight: 700;
    line-height: 1.4;
}
.details {
    font-size: 15px;
    line-height: 1.3;
}
.outline-red {
    border: 2px solid rgb(239, 44, 22);
}
textarea::placeholder {
    color: lightgray;
    font-style: italic;
}
</style>

<script>
    import { mapState } from 'vuex'

    export default {
        props: {
            indicator: Object,
            scoringLabels: Object
        },

        methods: {
            updateIndicator (e, updated) {
                let data = {
                    assessment_cycle_id: this.cycle.id,
                    section_number: this.indicator.section_number,
                    indicator_number: this.indicator.indicator_number
                }
                if (updated == 'grade') {
                    data.grade = e.target.value
                }
                if (updated == 'comment') {
                    data.comment = e.target.value
                }
                this.$store.dispatch('initial/saveInitialIndicator', data)
            }
        },

        computed: {
            ...mapState({
                initialIndicators: state => state.initial.initialIndicators,
                cycle: state => state.cycle.cycle
            }),
            initialIndicator () {
                return this.initialIndicators[this.indicator.section_number][this.indicator.indicator_number] || {}
            }
        }
    }
</script>
